import SupportedVideoExtensions from './SupportedVideoExtensions';
import SupportedAudioExtensions from './SupportedAudioExtensions';

export default [...SupportedVideoExtensions, ...SupportedAudioExtensions] as const;
